var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { ApiClient } from '../../api/apiClient';
import { BookingPreferences } from '../vehicle/BookingPreferences';
import { useForm } from '../../context/FormContext';
export var OnlineEstimation = function (_a) {
    var _b, _c, _d, _e, _f, _g;
    var onNext = _a.onNext, onBack = _a.onBack, formData = _a.formData, refreshData = _a.refreshData, setDisablePreviousSteps = _a.setDisablePreviousSteps;
    var formState = useForm().state;
    // Form field state
    var _h = useState(''), location = _h[0], setLocation = _h[1];
    var _j = useState(null), userState = _j[0], setUserState = _j[1];
    var _k = useState(false), isSuccess = _k[0], setIsSuccess = _k[1];
    var _l = useState(null), bookingDetails = _l[0], setBookingDetails = _l[1];
    // Form submission state
    var _m = useState(false), isSubmitting = _m[0], setIsSubmitting = _m[1];
    var _o = useState(null), formError = _o[0], setFormError = _o[1];
    var _p = useState(true), isLoadingSavedData = _p[0], setIsLoadingSavedData = _p[1];
    // Add new state for offer estimation
    var _q = useState(null), offerEstimation = _q[0], setOfferEstimation = _q[1];
    // Add this with your other state declarations at the top of the component
    var _r = useState(false), isLoadingEstimation = _r[0], setIsLoadingEstimation = _r[1];
    var _s = useState(null), estimationError = _s[0], setEstimationError = _s[1];
    // Add locations state
    var _t = useState([]), locations = _t[0], setLocations = _t[1];
    // Update form fields when formData changes
    useEffect(function () {
        var _a, _b, _c;
        if (formData) {
            // Only set location and state if not excluded
            if (!((_a = formState.exclusionStatus) === null || _a === void 0 ? void 0 : _a.isExcluded)) {
                // Pre-fill with u_preferred_location if set, otherwise use u_closest_location
                if (formData.u_preferred_location) {
                    setLocation(formData.u_preferred_location);
                }
                else if (formData.u_closest_location) {
                    setLocation(formData.u_closest_location);
                }
                if (formData.u_state) {
                    setUserState(Number(formData.u_state));
                }
            }
            setIsLoadingSavedData(false);
        }
        else {
            // If no form data passed, fallback to window.tiofSettings
            var fallbackData = ((_b = window.tiofSettings) === null || _b === void 0 ? void 0 : _b.savedData) || {};
            // Only set location and state if not excluded
            if (!((_c = formState.exclusionStatus) === null || _c === void 0 ? void 0 : _c.isExcluded)) {
                // Pre-fill with u_preferred_location if set, otherwise use u_closest_location
                if (fallbackData.u_preferred_location) {
                    setLocation(fallbackData.u_preferred_location);
                }
                else if (fallbackData.u_closest_location) {
                    setLocation(fallbackData.u_closest_location);
                }
                if (fallbackData.u_state) {
                    setUserState(Number(fallbackData.u_state));
                }
            }
            setIsLoadingSavedData(false);
        }
    }, [formData, formState.exclusionStatus]);
    // Fetch locations when component mounts or when userState becomes available
    useEffect(function () {
        var fetchLocations = function () { return __awaiter(void 0, void 0, void 0, function () {
            var response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, ApiClient.fetchAvailableLocations(userState !== null && userState !== void 0 ? userState : undefined)];
                    case 1:
                        response = _a.sent();
                        if (response.success && response.data) {
                            setLocations(response.data);
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        fetchLocations();
    }, [userState]);
    // Update form fields when formData changes
    useEffect(function () {
        var _a;
        var fetchOfferEstimation = function () { return __awaiter(void 0, void 0, void 0, function () {
            var vehicleDetails, requestData, result, estimationData, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!formData || !formState.vehicleDetails) {
                            return [2 /*return*/];
                        }
                        setIsLoadingEstimation(true);
                        setEstimationError(null);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        vehicleDetails = formState.vehicleDetails;
                        requestData = {
                            session_id: (formData === null || formData === void 0 ? void 0 : formData.tiof_session_id) || '',
                            variant_code: (vehicleDetails === null || vehicleDetails === void 0 ? void 0 : vehicleDetails.variantCode) || '',
                            odometer: (formData === null || formData === void 0 ? void 0 : formData.v_mileage) || (formData === null || formData === void 0 ? void 0 : formData.v_odometer) || '0',
                            state: (formData === null || formData === void 0 ? void 0 : formData.u_state) || (formData === null || formData === void 0 ? void 0 : formData.vehicle_state) || '0', // This should be the user's state, not vehicle state
                            manufacturing_year: (vehicleDetails === null || vehicleDetails === void 0 ? void 0 : vehicleDetails.manufactureYear) || '0',
                            rego: (vehicleDetails === null || vehicleDetails === void 0 ? void 0 : vehicleDetails.registrationNumber) || (formData === null || formData === void 0 ? void 0 : formData.vehicle_rego) || '',
                            answers: (formData === null || formData === void 0 ? void 0 : formData.v_condition_info) || '[]',
                            options: (vehicleDetails === null || vehicleDetails === void 0 ? void 0 : vehicleDetails.selectedOptions) ? JSON.stringify(vehicleDetails.selectedOptions) : '[]',
                            packs: (vehicleDetails === null || vehicleDetails === void 0 ? void 0 : vehicleDetails.selectedPacks) ? JSON.stringify(vehicleDetails.selectedPacks) : '[]'
                        };
                        return [4 /*yield*/, ApiClient.fetchFinalOfferEstimation(requestData)];
                    case 2:
                        result = _a.sent();
                        if (result.success && result.data && Array.isArray(result.data) && result.data.length > 0) {
                            estimationData = result.data[0];
                            setOfferEstimation({
                                minPrice: estimationData.PriceRangeLowValue,
                                maxPrice: estimationData.PriceRangeHighValue
                            });
                        }
                        else {
                            if (!result.success) {
                                throw new Error(result.error || 'Failed to get estimation data');
                            }
                            else if (!Array.isArray(result.data)) {
                                throw new Error('Invalid estimation data format');
                            }
                            else if (result.data.length === 0) {
                                throw new Error('No estimation data available');
                            }
                        }
                        return [3 /*break*/, 5];
                    case 3:
                        error_2 = _a.sent();
                        setEstimationError(error_2 instanceof Error ? error_2.message : 'Failed to calculate estimate');
                        return [3 /*break*/, 5];
                    case 4:
                        setIsLoadingEstimation(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        if (!((_a = formState.exclusionStatus) === null || _a === void 0 ? void 0 : _a.isExcluded)) {
            fetchOfferEstimation();
        }
    }, [formData, formState.vehicleDetails, formState.exclusionStatus]);
    useEffect(function () {
        var _a;
        if (!((_a = formState.exclusionStatus) === null || _a === void 0 ? void 0 : _a.isExcluded) && (userState === 2 || userState === 3)) {
            setDisablePreviousSteps(false);
        }
        else {
            setDisablePreviousSteps(true);
        }
    }, [formState.exclusionStatus, userState, setDisablePreviousSteps]);
    var handleSubmitLocation = function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!location) {
                        setFormError('Please select an inspection location');
                        return [2 /*return*/];
                    }
                    setIsSubmitting(true);
                    setFormError(null);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, 5, 6]);
                    if (!refreshData) return [3 /*break*/, 3];
                    return [4 /*yield*/, refreshData()];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3:
                    onNext();
                    return [3 /*break*/, 6];
                case 4:
                    error_3 = _a.sent();
                    setFormError('Failed to submit form. Please try again.');
                    return [3 /*break*/, 6];
                case 5:
                    setIsSubmitting(false);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var handleSubmit = function (success, details) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (success && details) {
                setIsSuccess(true);
                setBookingDetails(details);
                // Don't refresh data here as it will trigger price re-estimation
                // if (refreshData) {
                //     await refreshData();
                // }
            }
            return [2 /*return*/];
        });
    }); };
    var renderExclusionMessage = function () {
        var _a, _b, _c, _d, _e, _f;
        return (_jsxs("div", { className: "exclusion-message", children: [_jsx("h2", { className: "text-center text-red", children: ((_c = (_b = (_a = window.tiofSettings) === null || _a === void 0 ? void 0 : _a.i18n) === null || _b === void 0 ? void 0 : _b.estimateAppointment) === null || _c === void 0 ? void 0 : _c.exclusionTitle) ||
                        'SORRY, WE ARE NOT ABLE TO PROVIDE A PRICE FOR YOUR VEHICLE RIGHT NOW.' }), _jsx("div", { className: "exclusion-reasons", children: _jsx("p", { className: "text-center max-900", children: _jsx("strong", { children: ((_f = (_e = (_d = window.tiofSettings) === null || _d === void 0 ? void 0 : _d.i18n) === null || _e === void 0 ? void 0 : _e.estimateAppointment) === null || _f === void 0 ? void 0 : _f.exclusionMessage) ||
                                'This may be due to the type or condition of the vehicle, but we are still interested in your car! We will be in touch soon to organise an inspection, so we can provide you with an accurate price.' }) }) })] }));
    };
    var shouldDisablePreviousSteps = formState.currentStep === 4 &&
        !( // allow previous step navigation only if...
        !((_b = formState.exclusionStatus) === null || _b === void 0 ? void 0 : _b.isExcluded) &&
            (formData.u_state === 2 || formData.u_state === 3));
    return (_jsx("div", { className: "online-estimation", children: isLoadingSavedData ? (_jsx("div", { className: "loading-message", children: "Loading your information..." })) : ((_c = formState.exclusionStatus) === null || _c === void 0 ? void 0 : _c.isExcluded) ? (renderExclusionMessage()) : (_jsxs(_Fragment, { children: [!estimationError && offerEstimation && typeof offerEstimation.minPrice === 'number' && typeof offerEstimation.maxPrice === 'number' && (_jsx(_Fragment, { children: _jsx("h2", { className: "text-center", children: ((_f = (_e = (_d = window.tiofSettings) === null || _d === void 0 ? void 0 : _d.i18n) === null || _e === void 0 ? void 0 : _e.estimateAppointment) === null || _f === void 0 ? void 0 : _f.title) ||
                            'Congratulations, We estimate your vehicle offer to be in the range of:' }) })), _jsx("h2", { className: 'text-center estimated-amt', children: (function () {
                        var hasValidEstimation = offerEstimation &&
                            typeof offerEstimation.minPrice === 'number' &&
                            typeof offerEstimation.maxPrice === 'number';
                        if (isLoadingEstimation) {
                            return 'Calculating estimate...';
                        }
                        else if (estimationError) {
                            return (_jsxs(_Fragment, { children: ["Sorry, Unable to calculate estimate at this time", _jsx("div", { className: "error-message text-sm mt-2", children: estimationError })] }));
                        }
                        else if (hasValidEstimation) {
                            return "$".concat(offerEstimation.minPrice.toLocaleString(), " - $").concat(offerEstimation.maxPrice.toLocaleString(), "*");
                        }
                        else {
                            return 'Sorry, Unable to calculate estimate at this time';
                        }
                    })() }), !estimationError && offerEstimation && typeof offerEstimation.minPrice === 'number' && typeof offerEstimation.maxPrice === 'number' && (_jsxs("div", { className: "text-center powered-by-redbook", children: ["Powered By ", _jsx("img", { src: "/app/plugins/trade-in-offer-form/assets/images/redbook-logo.png", alt: "Redbook" })] })), !((_g = formState.exclusionStatus) === null || _g === void 0 ? void 0 : _g.isExcluded) && (!estimationError && offerEstimation && typeof offerEstimation.minPrice === 'number' && typeof offerEstimation.maxPrice === 'number' && (_jsx(BookingPreferences, { isSubmitting: isSubmitting, onLocationChange: setLocation, savedLocation: location, onSubmit: handleSubmit, locations: locations, userStateId: userState, minPrice: offerEstimation.minPrice, maxPrice: offerEstimation.maxPrice }))), formError && (_jsx("div", { className: "error-message", children: formError }))] })) }));
};
